import { prepareCommonRailData, sendRail } from "~/features/configurator/Rail/api/sendRailCommon";
import { type LinearConfiguration } from "~/features/configurator/Linear/models";
import {
  prepareApiDataForResetNew,
  prepareGroupIdToDisplay,
} from "~/features/configurator/common/commonConfiguratorApi";
import { type LinearConfiguratorState } from "~/features/configurator/Linear/redux/types";

export function sendRailDataReset(linearState: LinearConfiguratorState): Promise<LinearConfiguration> {
  const data = prepareCommonRailData(linearState);
  const resetData = prepareApiDataForResetNew(linearState);

  prepareGroupIdToDisplay(data);

  return sendRail({
    ...data,
    ...resetData,
    railsConfiguratorData: {
      ...data.railsConfiguratorData,
      reset: true,
    },
  });
}
